<template></template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BookmakerAccountValidator',
  components: {},
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'request:bookmakerAccountDetailsAccepted',
      async ({ responseId, ...data }) => {
        const response = await this.acceptBookmakerAccountIdDetails(data)
        this.$Events.dispatchEvent(responseId, response)
      },
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async acceptBookmakerAccountIdDetails(data) {
      if (!/(1xbet)|(betwinner)/i.test(data.service))
        return { canContinue: true }

      let responseGot = false
      if (!data?.hideLoading) {
        setTimeout(() => {
          if (responseGot) return
          this.$Events.dispatchEvent('start_loading')
        }, 500)
      }
      const accountDetails = await this.$Events.sendDataRequestResolve(
        'bookmakerAccountDetails',
        data,
      )
      responseGot = true
      if (!data?.hideLoading) {
        this.$Events.dispatchEvent('finish_loading')
      }
      if (!accountDetails?.success) {
        this.$Events.dispatchEvent('toast_notification', {
          title: this.$t('bokmakerAccountValidator.incorrectDetails'),
          body:
            accountDetails?.message ||
            this.$t('bokmakerAccountValidator.unableToRetrieveDetails'),
          timeout: 10000,
        })
        return { canContinue: false, resetValue: true }
      }
      const prompt = await window.choicePrompt({
        title: accountDetails.message,
        isBottomSheet: !!data.promptInBotomSheet,
        isModal: !data.promptInBotomSheet,
        options: [
          {
            name: `${this.$t('bokmakerAccountValidator.correctAccount')} ${data.service}`,
            id: 'ok',
          },
          {
            name: `${this.$t('bokmakerAccountValidator.incorrectAccount')} ${data.service}`,
            id: 'reset',
          },
        ],
        formatDisplay: data => data.name || '',
        successText: this.$t('bokmakerAccountValidator.continue'),
      })
      await new Promise(r => setTimeout(r, 1000))

      if (!prompt.accepted || !prompt.data)
        return { canContinue: false, resetValue: false }
      if (prompt.data.id == 'reset')
        return { canContinue: false, resetValue: true }

      return { canContinue: true, resetValue: false }
    },
  },
})
</script>
